import { createSlice } from '@reduxjs/toolkit';

export type PlatformEnvironmentName = 'PROD' | 'STAG';
export type RuntimeEnvironmentName = PlatformEnvironmentName;

type RuntimeConfigState = {
  environmentName: PlatformEnvironmentName;
};

type RuntimeConfigStateContainer = {
  runtimeConfig: RuntimeConfigState;
};

export const normalizePlatformEnvironmentName = (
  value?: string | null
): PlatformEnvironmentName => {
  const normalized = value?.trim().toUpperCase();

  if (normalized === 'PROD' || normalized === 'PRODUCTION') {
    return 'PROD';
  }

  if (
    normalized === 'STAG' ||
    normalized === 'STAGING' ||
    normalized === 'DEV' ||
    normalized === 'DEVELOPMENT' ||
    normalized === 'TEST'
  ) {
    return 'STAG';
  }

  return 'STAG';
};

export const resolvePlatformEnvironmentName = (): PlatformEnvironmentName =>
  normalizePlatformEnvironmentName(
    process.env.ENV_NAME || process.env.REACT_APP_ENV_NAME || process.env.NODE_ENV
  );

export const normalizeRuntimeEnvironmentName = normalizePlatformEnvironmentName;
export const resolveRuntimeEnvironmentName = resolvePlatformEnvironmentName;

const initialState: RuntimeConfigState = {
  environmentName: resolvePlatformEnvironmentName(),
};

const runtimeConfigSlice = createSlice({
  name: 'runtimeConfig',
  initialState,
  reducers: {},
});

export const selectPlatformEnvironmentName = (state: RuntimeConfigStateContainer) =>
  state.runtimeConfig.environmentName;

export const selectRuntimeEnvironmentName = selectPlatformEnvironmentName;

export default runtimeConfigSlice.reducer;
